<template>
    <v-card v-if="chart == 'OFF'" class="d-flex flex-wrap flex-as-display card" :id="laboratory.name">
        <v-card-text style="width: auto; text-align: left; flex:1 0 75%; padding: 0 16px;" class="d-flex flex-column">
            <div class="lab-header-simple">
                <div class="lab-title-simple">
                    <template v-if="laboratoryRank == 0">
                        <img src="images/one.png" style="width: 36px; height: 36px; margin-bottom: 2px; margin-right: 24px;"/>
                        <div>
                            <span id="course" :type="laboratory.course == '物質材料コース'">{{ laboratory.course }}</span><br>
                            <span @mouseover="changeCursor" @mouseout="resetCursor" @click="chartChange">{{ laboratory.name }}</span>
                        </div>
                    </template>
                    <template v-else-if="laboratoryRank == 1">
                        <img src="images/two.png" style="width: 36px; height: 36px; margin-bottom: 2px; margin-right: 24px;"/>
                        <div>
                            <span id="course" :type="laboratory.course == '物質材料コース'">{{ laboratory.course }}</span><br>
                            <span @mouseover="changeCursor" @mouseout="resetCursor" @click="chartChange">{{ laboratory.name }}</span>
                        </div>
                    </template>
                    <template v-else-if="laboratoryRank == 2">
                        <img src="images/three.png" style="width: 36px; height: 36px; margin-bottom: 2px; margin-right: 24px;"/>
                        <div>
                            <span id="course" :type="laboratory.course == '物質材料コース'">{{ laboratory.course }}</span><br>
                            <span @mouseover="changeCursor" @mouseout="resetCursor" @click="chartChange">{{ laboratory.name }}</span>
                        </div>
                    </template>
                    <template v-else-if="laboratoryRank < setting.others_laboratories">
                        <span id="lab_rank" :type="laboratoryRank >= 9">{{ laboratoryRank + 1 }}</span>
                        <div>
                            <span id="course" :type="laboratory.course == '物質材料コース'">{{ laboratory.course }}</span><br>
                            <span @mouseover="changeCursor" @mouseout="resetCursor" @click="chartChange">{{ laboratory.name }}</span>
                        </div>
                    </template>
                    <template v-else>
                        <span>
                            <div style="margin-left: 60px;">
                                <span id="course" :type="laboratory.course == '物質材料コース'">{{ laboratory.course }}</span><br>
                                <span @mouseover="changeCursor" @mouseout="resetCursor" @click="chartChange">{{ laboratory.name }}</span>
                            </div>
                        </span>
                    </template>
                </div>
                <div id="professors">
                    <div>
                        <template v-if="!laboratory.professors[0].name">
                        </template>
                        <template v-else-if="laboratory.professors[0].class">
                            <span style="font-size: 11px; color: white; background-color: #888; padding: 2px 8px;  margin: 0 12px 0 0; white-space: nowrap;">{{ laboratory.professors[0].class }}</span>
                            <template v-if="windowWidth > simpleChartSwitchWidth && windowWidth < computerWidth">
                                <br>
                                <span style="font-size: 13px; color: black;">{{ laboratory.professors[0].name }}</span>
                            </template>
                            <template v-else>
                                <span style="font-size: 13px; color: black;">{{ laboratory.professors[0].name }}</span>
                            </template>
                        </template>
                        <template v-else>
                            <img style="width: 14px; height: 14px; margin-bottom: -2px;" src="images/material-symbols_person.png"/>
                            <span style="font-size: 13px; margin: 0 0 0 12px; color: black;">{{ laboratory.professors[0].name }}</span>
                        </template>
                    </div>
                    <div v-if="laboratoryRank < setting.score_visible_min_rank && similarity >= setting.score_visible_min_similarity">
                        <span id="similarity-simple">{{ similarity }}</span>
                        <span id="similarity-percent-simple">%</span>
                    </div>
                </div>
                <v-btn style="background-color: #FFF; border: solid 1px black; box-shadow: none; width: auto;" id="btn-simple" @click="chartChange">詳細を見る ></v-btn>
            </div>
            <div v-if="setting.score_debug == 'ON'" style="font-size: 12px; margin: 0 16px;">
                （検証用）得意科目の適合度 : {{ (this.laboratory.similarity_subjects * 100).toFixed(1) }}
                、キーワードの適合度 : {{ (this.laboratory.similarity_keywords * 100).toFixed(1) }}、総合スコア : {{ similarity }}
            </div>
        </v-card-text>
    </v-card>
    <v-card v-else class="d-flex flex-wrap flex-as-display" :id="laboratory.name">
        <v-card-text style="width: auto; text-align: left; flex:1 0 75%;" class="d-flex flex-column">
            <div>
                <div class="lab-header">
                    <div class="lab-title">
                        <template v-if="laboratoryRank == 0">
                            <img src="images/one.png" style="width: 36px; height: 36px; margin-bottom: -3px; margin-right: 24px;"/>
                            {{ laboratory.name }}
                        </template>
                        <template v-else-if="laboratoryRank == 1">
                            <img src="images/two.png" style="width: 36px; height: 36px; margin-bottom: -3px; margin-right: 24px;"/>
                            {{ laboratory.name }}
                        </template>
                        <template v-else-if="laboratoryRank == 2">
                            <img src="images/three.png" style="width: 36px; height: 36px; margin-bottom: -3px; margin-right: 24px;"/>
                            {{ laboratory.name }}
                        </template>
                        <template v-else-if="laboratoryRank < setting.others_laboratories">
                            <span style="color: #00a0e9; margin-right: 24px;">{{ laboratoryRank + 1 }}</span>
                            {{ laboratory.name }}
                        </template>
                        <template v-else>
                            <span>{{ laboratory.name }}</span>
                        </template>
                        <template v-if="windowWidth > smartphoneWidth">
                            <img :src="courseIcon(laboratory.course)" style="width: 100px; height: 48px; margin-left: 24px; margin-bottom: -12px;"/>
                        </template>
                        <template v-else>
                            <div style="display: flex; justify-content: space-between; align-items: flex-end;">
                                <div style="height: 36px; margin-bottom: 16px;">
                                    <img :src="courseIcon(laboratory.course)" style="width: 100px; height: 56px;" :aspect-ratio= "16 / 9"/>
                                </div>
                                <div v-if="laboratoryRank < setting.score_visible_min_rank && similarity >= setting.score_visible_min_similarity">
                                    <span style="color: red; font-size: 36px; font-weight: bold;">{{ similarity }}</span>
                                    <span style="color: red; font-size: 16px;">%</span>
                                </div>
                            </div>
                        </template>
                    </div>
                    <div v-if="laboratoryRank < setting.score_visible_min_rank && similarity >= setting.score_visible_min_similarity && windowWidth > smartphoneWidth">
                        <span style="margin-left: 12px;">マッチング率</span> 
                        <span style="color: red; font-size: 36px; font-weight: bold; margin-left: 12px;">{{ similarity }}</span>
                        <span style="color: red; font-size: 16px;">%</span>
                    </div>
                </div>
                <div style="text-align: left; margin-left: 20px; margin-top: 20px;" class="d-flex flex-wrap align-center">
                    <div v-for="professors in laboratory.professors" :key="professors.id">
                        <template v-if="!professors.name">
                        </template>
                        <template v-else-if="professors.class">
                            <span style="font-size: 11px; color: white; background-color: #888; padding: 2px 8px 2px 8px;" :key="professors.id">{{ professors.class }}</span>
                            <span style="font-size: 13px; margin: 0 48px 0 12px; color: black;" :key="professors.name">{{ professors.name }}</span>
                        </template>
                        <template v-else>
                            <img style="width: 14px; height: 14px; margin-bottom: -2px;" src="images/material-symbols_person.png" :key="professors.id"/>
                            <span style="font-size: 13px; margin: 0 48px 0 12px; color: black;" :key="professors.name">{{ professors.name }}</span>
                        </template>
                    </div>
                </div>
                <div class="d-flex flex-wrap align-center" style="margin-left: 12px; margin-top: 20px;">
                    <v-chip v-for="featuredKeyword in featuredKeywords" :key="featuredKeyword.name" label outlined small
                        class="ml-2 my-1" :color="featuredKeyword.color">
                        {{ featuredKeyword.name }}
                    </v-chip>
                </div>
            </div>
            <div class="d-flex lab-explanation">
                <div class="lab-description">
                    <span style="color:rgb(54,54,54); white-space: pre-wrap;">{{ laboratory.description }}<br></span>
                </div>
                <div class="lab-thumbnail">
                    <v-img contain :src="laboratory.thumbnail" style="height: 30vh;" :aspect-ratio="16 / 9" />
                </div>
            </div>
            <div v-if="windowWidth > smartphoneWidth" style="display: flex; justify-content: space-between;">
                <v-btn style="background-color: #FFF; border: solid 1px black; box-shadow: none; padding: 0 8px; margin-left: 16px;" @click="chartChange">&lt; シンプルチャートで見る</v-btn>
                <lab-link :href="laboratory.laboratory_link" class="align-self-end" style="margin-bottom: 16px; margin-right: 16px;"/>
            </div>
            <div v-else style="display: flex; flex-direction: column; align-items: flex-start;">
                <v-btn style="background-color: #FFF; border: solid 1px black; box-shadow: none; font-size: 10px; padding: 0 8px; margin-bottom: 16px;" @click="chartChange">&lt; シンプルチャートへ</v-btn>
                <lab-link :href="laboratory.laboratory_link" class="align-self-end" style="margin-bottom: 16px; width: 100%;"/>
            </div>
            <div v-if="setting.score_debug == 'ON'" style="margin: 0 16px;">
                （検証用）得意科目の適合度 : {{ (this.laboratory.similarity_subjects * 100).toFixed(1) }}
                、キーワードの適合度 : {{ (this.laboratory.similarity_keywords * 100).toFixed(1) }}、総合スコア : {{ similarity }}
            </div>
        </v-card-text>
    </v-card>
</template>


<script>
import LabLink from "../components/LabLink.vue"

export default {
    components: {
        LabLink
    },
    props: {
        subject_sort: {
            type: Boolean,
        },
        attribute: {
            type: Object,
            required: true,
        },
        laboratory: {
            type: Object,
            required: true,
        },
        setting: {
            type: Object,
            required: true,
        },
        index: {
            type: Number,
            required: true,
        },
        laboratoriesCount: {
            type: Number,
            required: true,
        },
        selectedKeywords: {
            type: Array,
            required: false,
            default: () => { return [] }
        },
        chart: {
            type: String
        },
        beforeLaboratories: {
            type: Array,
            required: true,
        },
    },
    data() {
        return {
            displayFeaturedKeywordsCount: this.setting.keyword_icon,
            windowWidth: window.innerWidth,
            smartphoneWidth: 450,
            simpleChartSwitchWidth: 600,
            computerWidth: 960,
        }
    },
    created() {
        window.addEventListener('resize', () => {
            this.windowWidth = window.innerWidth;
        });
    },
    methods: {
        courseIcon(course){
            if(course == "物質材料コース"){
                return "images/material.png";
            }else if(course == "機械電気コース"){
                return "images/electrical.png";
            }
        },
        chartChange(){
            this.$emit('cardClick', this.laboratory.name)
        },
        changeCursor() {
            // マウスが要素に入った時の処理
            this.$el.style.cursor = 'pointer';
        },
        resetCursor() {
            // マウスが要素から出た時の処理
            this.$el.style.cursor = 'default';
        },
    },
    computed: {
        similarity() {
            if(this.attribute.target_subjects == null){
                return (this.laboratory.similarity_keywords * 100).toFixed(1)
            }
            else if(!this.subject_sort){
                return (this.laboratory.similarity_keywords * 100).toFixed(1)
            }
                return (((this.laboratory.similarity_subjects + this.laboratory.similarity_keywords) / 2) * 100).toFixed(1)
        },
        sortedKeywordWeights() {
            const keywordWeights = Object.entries(this.laboratory.keyword_weights)
            return keywordWeights.toSorted((a, b) => {
                return a[1] > b[1] ? -1 : 1
            }).slice(0, this.displayFeaturedKeywordsCount)
        },
        laboratoryRank() {
            let count = 0;
            this.beforeLaboratories.forEach(laboratory => {
                let before_similarity;
                if(this.attribute.target_subjects == null || !this.subject_sort) {
                    before_similarity = (laboratory.similarity_keywords * 100).toFixed(1);
                }
                else {
                    before_similarity = (((laboratory.similarity_subjects + laboratory.similarity_keywords) / 2) * 100).toFixed(1)
                }
                if(Number(before_similarity) > Number(this.similarity)) {
                    count++;
                }
            })
            this.$emit('labRank', count, this.index);
            return count;
        },
        featuredKeywords() {
            return this.sortedKeywordWeights.map((keyword) => {
                return {
                    name: keyword[0],
                    color: this.selectedKeywords.includes(keyword[0]) ? 'success' : 'failure'
                }
            })
        },
    }
}

</script>

<style scoped>
.card {
    border-top: none;
    border-radius: 0;
}
#lab_rank {
    color: #00a0e9;
    margin-left: 12px;
    margin-right: 36px;
}
#lab_rank[type='true'] {
    margin-left: 0;
    margin-right: 36px;
}
#course {
    padding-left: 2px;
    font-size: 12px;
    font-weight: none;
    color: #176E9A;
}
#course[type='true'] {
    color: #807512;
}
#professors {
    flex: 3;
    margin-left: 60px;
    margin-top: 4px;
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
}
#similarity-simple {
    color: red;
    font-size: 30px;
    font-weight: bold;
    margin-left: 12px;
}
#similarity-percent-simple {
    color: red;
    font-size: 16px;
}
.lab-header-simple {
    display: flex;
    flex-direction: column;
    margin: 16px;
}
.lab-title-simple {
    flex: 5;
    color:rgb(74,74,74);
    font-size: 16px;
    font-weight: bold;
    display: flex;
    text-align: left;
    line-height: 1.2;
    align-items: flex-end;
}
#btn-simple {
    margin: 12px 0;
}
.lab-header {
    display: flex;
    flex-direction: column;
    margin: 16px;
}
.lab-title {
    color:rgb(74,74,74);
    font-size: 16px;
    font-weight: bold;
}
.lab-explanation {
    overflow:hidden;
    width: 100%;
    flex-direction: column-reverse;
}
.lab-description {
    text-align: left;
    margin: 8px;
}
.lab-thumbnail {
    width: 90%;
    margin: 16px;
}
@media (min-width: 450px) {
    .lab-header {
        display: flex;
        align-items: end;
        justify-content: space-between;
        flex-direction: row;
        margin: 16px;
    }
}
@media (min-width: 600px) {
    #btn-simple {
        margin: 0;
        margin-left: 32px;
        font-size: 1.45vw;
    }
    #professors {
        margin-left: 8px;
    }
    #similarity-simple {
        font-size: 3.125vw;
    }
    #similarity-percent-simple {
        font-size: 1.6vw;
    }
    .lab-header-simple {
        display: flex;
        align-items: end;
        justify-content: space-between;
        flex-direction: row;
        margin: 16px;
    }
}
@media (min-width: 960px) {
    #btn-simple {
        font-size: 14px;
    }
    #similarity-simple {
        font-size: 30px;
    }
    #similarity-percent-simple {
        font-size: 16px;
    }
    .lab-title-simple {
        font-size: 20px;
    }
    .lab-title {
        font-size: 24px;
    }
    .lab-explanation {
        flex-direction: row;
    }
    .lab-description {
        width: 60%;
        margin: 16px;
    }
    .lab-thumbnail {
        width: 40%;
        align-items: flex-start;
    }
}
@media (min-aspect-ratio: 1/1) {
    .flex-as-display {
        flex-direction: row;
    }

    .flex-as-display>.lab-description {
        flex: 1 0 75% !important
    }

    .flex-as-display>.lab-thumbnail {
        flex: 1 0 25% !important
    }

}

@media (max-aspect-ratio: 1/1) {
    .flex-as-display {
        flex-direction: column;
    }

    .flex-as-display>.lab-description {
        flex: 1 0 100% !important
    }

    .flex-as-display>.lab-thumbnail {
        flex: 1 0 100% !important;
        width: 100%;
    }
}
</style>